import { createStore } from 'easy-peasy';
import services from '../services';
import stores from '../stores';

export const store = createStore(stores, { injections: services });
